import React from "react";
import classNames from "classnames";
import ButtonMinus from "./ButtonMinus";
import ButtonPlus from "./ButtonPlus";

function ButtonCounter({
	className = "",
	size = "sm",
	onClickCounter,
	onClickMinusBtn,
	onClickPlusBtn,
	quantity,
    quantityHandler,
    minlimit,
    inputBlurHandler,
	...props
}) {
    // Никотин: кратность 5 — правило товара, остаётся всегда.
    // Остаток склада клиенту не показываем и количество им не ограничиваем.
	const classes = classNames("counter counter-" + size, className);


    const handleInput = e => {
        let currentValue = Number(e.target.value);
        quantityHandler(currentValue);
    }

    const handleBlur = e => {
        let currentValue = Number(e.target.value);
        if (!Number.isFinite(currentValue) || currentValue < minlimit) {
            currentValue = minlimit;
        }
        // кратность 5 (правило товара, не связано с остатком)
        currentValue = Math.ceil(currentValue / 5) * 5;
        e.target.value = currentValue;
        inputBlurHandler(currentValue);
    }

    let ctrRef = React.useRef();

	return (
		<div className={classes} onClick={onClickCounter}>
			<div className="counter__content">
				<ButtonMinus
					onClick={onClickMinusBtn}
					className={size === "md" ? "button-minus-md" : "button-minus-sm"}
				/>
				<input ref={ctrRef} 
				    type="number" 
				    className="counter__body" 
				    onChange={handleInput}
				    onBlur={handleBlur}
				    value={quantity} 
				    style={{'width': '4.5rem', 'border': 'none', 'padding': '0', 'margin': 'auto', 'text-align': 'center'}}
				/>
				<ButtonPlus
					onClick={onClickPlusBtn}
					className={size === "md" ? "button-plus-md" : "button-plus-sm"}
				/>
			</div>
			
		</div>
        
        
	);
}

export default ButtonCounter;
